/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ResourceCredentialSchema } from './ResourceCredentialSchema';

export const ListCredentialSchema: core.serialization.ObjectSchema<
    serializers.ListCredentialSchema.Raw,
    Truvity.ListCredentialSchema
> = core.serialization.object({
    items: core.serialization.list(ResourceCredentialSchema),
});

export declare namespace ListCredentialSchema {
    export interface Raw {
        items: ResourceCredentialSchema.Raw[];
    }
}
